import axios from "axios";

export default function addComment({ ticketId, content, isInternal = false }) {
  return new Promise((resolve, reject) =>
    axios
      .post(`/support/api/v1/admin/tickets/${ticketId}/comments`, {
        content,
        is_internal: isInternal,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
